import { useState, useCallback, useMemo } from 'react';
import { TextField,Container } from "@mui/material";
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers';

var style1={
  margin:"auto",
  textAlign:"center",
};

class User{
   constructor(name,password,email,gender,dob){
     this.username=name;
     this.password=password;
     this.email=email;
     this.gender=gender;
     this.dob=dob;
   }
}

function validateEmail(mail) {
 return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
}

function Signup(props) {
  const [open, setOpen] = useState(false);
  const [text,changeText] = useState("Please enter your name");
  const [date, changeDate] = useState(null);
  const [gender,changeGender] = useState("Male");
  const [heading,changeHeading] = useState("Server Response CODE : ");
  const [isSigned,signed] = useState(false);
  const handleChange = (newValue) => { changeDate(newValue); };

  var container = useMemo(()=>{
    return {
      margin:"auto",
      textAlign:"center",
      padding: "15px",
      paddingTop: "20px",
      paddingBottom: "0",
      backgroundColor: props.color,
      borderRadius: "10px",
    };
  },[props.color]);

  const handleClickOpen = useCallback(() => {
    let missing = "";
    let name = document.getElementById("name").value,
    email = document.getElementById("email").value,
    pass = document.getElementById("pass").value;
    if(name === "" || email === "" || pass === "" || date === null){
      if(name === "") missing += "username ";
      if(email === "") missing += "email ";
      if(pass === "") missing += "password ";
      if(date === null) missing += "DOB";
      changeText("Please Enter the following fields :\n"+missing);
      changeHeading("Empty Fields not Allowed");
      setOpen(true);
    }
    else if(!validateEmail(email)){
      changeText("Please Enter a valid Email");
      changeHeading("Invalid Email");
      setOpen(true);
    }
    else{
      let user = new User(name,pass,email,gender,document.getElementById("dob").value),
      config = {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          "X-CSRFToken": props.csrf //TODO: Generate CSRF-Token
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(user) // body data type must match "Content-Type" header
      };
      fetch("",config).then(res=>{
        changeHeading("Server Response CODE : "+res.status.toString());
        if(res.status === 200){
          res.json().then(data =>{ 
            if(data == "User Signup Sucessfull") signed(true);
            changeText(data);
            setOpen(true);
          }).catch(err => { 
            console.info(err); 
            changeText("Invalid Data Received from Server");
            setOpen(true);
          })
        }
        else{
          changeText(res.statusText);
          setOpen(true);
        }
      }).catch(err=>{
        console.info(err);
        changeHeading("Something is not Right");
        changeText("Signup not Sucessfull");
        setOpen(true);
      });
    }
  },[date,gender,props.csrf]);

  const handleClose = useCallback(() => { 
    setOpen(false); 
    if(isSigned) 
    document.getElementById('linkedToLogin').click();
  },[isSigned]);
  const handleGender = evt => { changeGender(evt.target.value); }
  
  return (
    <>
      <h1 style={style1}><u>Signup for a new Account</u></h1><br/>
      <Container maxWidth="sm" style={container}>
      <TextField id="name" label="Enter your name" variant="outlined" type={"text"} 
      sx={{ input: { color: props.textColor } }}
      InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
      <TextField id="pass" label="Enter Password" variant="outlined" type={"password"} 
      sx={{ input: { color: props.textColor } }}
      InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
      <TextField id="email" label="Enter Mail-ID" variant="filled" type={"email"} 
      sx={{ input: { color: props.textColor } }}
      InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>

      {/*Radio buttons for Gender*/}
      <FormControl>
      <FormLabel id="demo-radio-buttons-group-label" style={{color:props.textColor}}>Gender</FormLabel>
      <RadioGroup
        row={true}
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={gender}
        name="radio-buttons-group" 
        onChange={handleGender}
      >
        <FormControlLabel value="Male" control={<Radio />} label="Male" />
        <FormControlLabel value="Female" control={<Radio />} label="Female" />
        <FormControlLabel value="Other" control={<Radio />} label="Other" />
      </RadioGroup>
      </FormControl>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack>
        <MobileDatePicker
          label="Enter D.O.B"
          inputFormat="dd-MM-yyyy"
          value={date}
          maxDate={new Date()}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} id="dob"
          sx={{ input: { color: props.textColor } }}
          InputLabelProps={{ style: { color: props.textColor } }}/>}
        />
      </Stack>
      </LocalizationProvider><br/>

      <Button variant="contained" onClick={handleClickOpen}>
        Signup
      </Button>
      <br/><br/>
      <br/><br/>
      </Container>
      <div>

      {/*Dialog-Box to display a message*/}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {heading}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </div><br/>
    <Link id="linkedToLogin" to="/login" style={{textAlign:"center",display:"block",margin:"auto",color:"white"}}><b>Already have an Account? Login</b></Link>
    </>
  );
}

export default Signup;